import { Button, Grid, IconButton, makeStyles, Theme, Tooltip, Typography } from '@material-ui/core';
import { Create, Delete, DeleteOutline, EditOutlined, Visibility, AttachFile, VisibilityOutlined } from '@material-ui/icons';
import clsx from 'clsx';
import { TableCellEnd, TableCellMiddle, TableCellStart, TableRowCustom } from 'components';

import { BLACK, PRIMARY_MOBILE, WHITE } from 'constants/colors';
import React from 'react';
import NumberFormat from 'components/NumberFormat';
import { format } from 'date-fns';
import { CashBalance } from 'typings/CashBalanceModel';
import { TData } from '..';
import useRouter from 'hooks/useRouter';

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    cursor: 'pointer',
    '&:hover': {
      color: PRIMARY_MOBILE
    }
  },
  cellStart: {
    width: '3%'
  },
  cellMiddle: {
    width: '14%'
  },
  cellMiddleDesc: {
    width: '15%'
  },
  cellEnd: {
    width: '15%',
    textAlign: 'right'
  },
  descriptionContainer: {
    backgroundColor: WHITE,
    borderRadius: '6px',
    boxShadow: '0 2px 5px rgb(0 0 0 / 14%)',
    border: '1px solid #E0E0E0'
  },
  description: {
    color: BLACK
  },
  gap: {
    marginBottom: theme.spacing(2)
  }
}));
interface Props {
  // journalTransactions: transactionJurnal;
  balanceSheet: any;
  cashBalance: any;
  handleAction: (isOpen: boolean, id: number, action: 'delete' | 'update' | 'detail') => void;
}
const TransactionBody = ({ balanceSheet, cashBalance, handleAction }: Props) => {
  const classes = useStyles();
  const { history } = useRouter();
  const handleLink = () => {
    history.push('/invoice-pembelian/detail', { id: balanceSheet.id });
  };

  return (
    <>
      <TableRowCustom key={cashBalance.id}>
        <TableCellStart className={clsx(classes.cellMiddle)} onClick={() => handleAction(true, balanceSheet.id, 'detail')}>
          {balanceSheet.name}
        </TableCellStart>
        <TableCellEnd className={clsx(classes.cellEnd)} onClick={() => handleAction(true, balanceSheet.id, 'detail')}>
          {balanceSheet.total < 0 ? (
            <NumberFormat value={Math.abs(balanceSheet.total)} prefix={'(Rp '} suffix={')'} thousandSeparator={true} displayType='text' />
          ) : (
            <NumberFormat value={balanceSheet.total} prefix={'Rp '} thousandSeparator={true} displayType='text' />
          )}
        </TableCellEnd>
      </TableRowCustom>
    </>
  );
};

export default TransactionBody;
